export const IT_HELPDESK_EMAIL = "itsupport@principleclean.com";